import { render, staticRenderFns } from "./CustomerFeatureList.vue?vue&type=template&id=606566ab&"
import script from "./CustomerFeatureList.vue?vue&type=script&lang=js&"
export * from "./CustomerFeatureList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports